/*
  Component: Live Donation
  Responsibility: the thousands separator in the running total, and nothing else.

  The figure itself is already on the page. sections/kl-live-donation.liquid reads it from a shop
  metafield while the page is being built, so this file never fetches anything, never waits for
  anything, and cannot leave a $0.00 on screen the way the Hydrogen storefront's own request does.

  WHY IT EXISTS AT ALL. A metafield holds "73187.40" — a plain decimal number, not a price in
  cents — and CLAUDE.md allows no math filters in Liquid, so Liquid cannot reach "73,187.40"
  without a multiplication it is not permitted to do. `money` counts cents and would need one. So
  Liquid renders the symbol and the raw number, and the grouping is done here.

  With this file missing the total still reads "$73187.40": correct, current and legible, just
  without its separators. That is the right thing to degrade to, and it is why the number is not
  written by script in the first place.

  THE GROUPING IS en-US AND NOT THE VISITOR'S LOCALE. The donation is one running total in one
  currency, not a price converted for whoever is browsing — and a visitor in an en-IN locale would
  otherwise see the same dollar figure grouped in lakhs. A number that changes shape by who is
  reading it invites the question of whether the amount changed too.
*/

/*
  Pure and DOM-free: "73187.40" as "73,187.40".

  Returns an empty string for anything that is not a number, so a metafield holding a word, or an
  empty one, leaves whatever Liquid already rendered rather than replacing it with "NaN".

  Two decimal places always, because a total that shows cents on one load and not the next reads
  as a different number rather than as the same one rounded.
*/
function formatDonationDigits(rawValue) {
  const amountNumber = Number.parseFloat(rawValue);

  if (!Number.isFinite(amountNumber)) return '';

  try {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountNumber);
  } catch (error) {
    console.debug('Live donation could not group its digits', { rawValue, error });
    return '';
  }
}

function initLiveDonation(rootElement) {
  const amountElement = rootElement.querySelector('[data-kl-live-donation-amount]');

  if (!amountElement) return;

  const groupedDigits = formatDonationDigits(amountElement.dataset.klLiveDonationAmount);

  /*
    Nothing to improve on. Either the metafield is not set — in which case the wording typed in
    the section settings is on screen and is the merchant's to keep — or it holds something that
    is not a number, which has already been logged above.
  */
  if (!groupedDigits) return;

  const currencySymbol = amountElement.dataset.klLiveDonationSymbol || '';

  amountElement.textContent = `${currencySymbol}${groupedDigits}`;
}

document.querySelectorAll('[data-kl-live-donation]').forEach(initLiveDonation);

// Theme editor: a re-rendered section arrives with fresh, ungrouped markup.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-live-donation]').forEach(initLiveDonation);
});
